export enum STATUS {
	NEW = 'NEW',
	OLD = 'OLD',
	DRAFT = 'DRAFT',
	SUBMITTED = 'SUBMITTED',
	CONFIRMED = 'CONFIRMED',
	PENDING = 'PENDING',
	VERIFIED = 'VERIFIED',
	APPROVED = 'APPROVED',
	REVIEWING = 'REVIEWING',
	REJECTED = 'REJECTED',
	RETURN = 'RETURN',
	RETURNED = 'RETURNED',
	ALLOCATE = 'ALLOCATE',
	ASSIGN = 'ASSIGN',
	SUSPENDED = 'SUSPENDED',
	REOPENED = 'REOPENED',
	CLOSED = 'CLOSED',
	DENIED = 'DENIED',
	PAID = 'PAID',
	CREATED = 'CREATED',
	DELETED = 'DELETED',
	ACCEPTED = 'ACCEPTED',
	OPEN = 'OPEN',
	TRANSFER_TO_DOCTOR = 'TRANSFER_TO_DOCTOR',
	TRANSFER_TO_CALCULATOR = 'TRANSFER_TO_CALCULATOR',

	HC_SUBMITTED = 'HC_SUBMITTED',
	HC_RETURNED = 'HC_RETURNED',
	HC_REJECTED = 'HC_REJECTED',
	HC_ACCEPTED = 'HC_ACCEPTED',
	BEN_HC_RETURNED = 'BEN_HC_RETURNED',
	DOCTOR_BEN_HC_RETURNED = 'DOCTOR_BEN_HC_RETURNED',
	DOCTOR_BEN_REJECTED = 'DOCTOR_BEN_REJECTED',

	LOCKED = 'LOCKED',
	FOLLOWED_UP = 'FOLLOWED_UP',
	COMPLETED = 'COMPLETED',
	TRANSFERRED = 'TRANSFERRED',
	CREATED_BENEFIT_NOTE = 'CREATED_BENEFIT_NOTE',
	REJECTED_BENEFIT_NOTE = 'REJECTED_BENEFIT_NOTE',

	RETURN_TO_OFFICER = 'RETURN_TO_OFFICER',
	RETURN_TO_DOCTOR = 'RETURN_TO_DOCTOR',
	REQUEST_EDIT = 'REQUEST_EDIT',
	ACTIVE = 'ACTIVE',
	EDIT_INVOICE = 'EDIT_INVOICE',
	UPDATED = 'UPDATED',
	CORRECTION = 'CORRECTION',

	ONLINE_SUBMITTED = 'ONLINE_SUBMITTED',
	ONLINE_RETURNED = 'ONLINE_RETURNED',
	INCOMPLETED = 'INCOMPLETED',
	TO_INSPECTION = 'TO_INSPECTION',
	RETURN_FROM_INS = 'RETURN_FROM_INS',
	INS_REJECTED = 'INS_REJECTED',
	CONTACTED = 'CONTACTED',
	NOT_CONTACTED = 'NOT_CONTACTED'
}

export enum MEMBER_STATUS {
	OPEN = 'OPEN',
	CLOSE = 'CLOSE',
}

export enum MONTHLY_PAYMENT_NOTE_TYPE {
	PERMANENT = "PERMANENT",
	SURVIVAL = "SURVIVAL"
}

export enum CASE_TYPE {
	NEW = "NEW",
	OLD = "OLD",
	SUSPEND = "SUSPEND"
}
